var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 6.91504V9.66671M15.5248 9.67112V6.91504M6.54823 1.2623L2.75586 5.03262V18.8792H7.33096V22.7377L11.2225 18.8792H14.3149L21.2437 12.011V1.2623H6.54823ZM8.43342 3.95776H18.6144V10.1314L16.7127 13.1135H13.6204L10.7981 15.9412L10.7981 13.1135H8.43342V3.95776Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitch);
export default __webpack_public_path__ + "static/media/twitch.01bf9d7bdaaef592ffd461e6c05034e7.svg";
export { ForwardRef as ReactComponent };